var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.30517C0.5 3.26761 2.96243 0.805176 6 0.805176H34C37.0376 0.805176 39.5 3.26761 39.5 6.30518V34.3052C39.5 37.3427 37.0376 39.8052 34 39.8052H6C2.96243 39.8052 0.5 37.3427 0.5 34.3052V6.30517Z",
    fill: "#18181B",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.30517C0.5 3.26761 2.96243 0.805176 6 0.805176H34C37.0376 0.805176 39.5 3.26761 39.5 6.30518V34.3052C39.5 37.3427 37.0376 39.8052 34 39.8052H6C2.96243 39.8052 0.5 37.3427 0.5 34.3052V6.30517Z",
    stroke: "#E2E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 25.3053V15.3053C14.6667 14.8633 14.8423 14.4394 15.1549 14.1268C15.4675 13.8143 15.8914 13.6387 16.3334 13.6387H25.3334V26.972H16.3334C15.8914 26.972 15.4675 26.7964 15.1549 26.4838C14.8423 26.1713 14.6667 25.7474 14.6667 25.3053ZM14.6667 25.3053C14.6667 24.8633 14.8423 24.4394 15.1549 24.1268C15.4675 23.8143 15.8914 23.6387 16.3334 23.6387H25.3334M18.6667 13.6387V18.972L20.6667 16.972L22.6667 18.972V13.6387",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/date-picker.9bfd75608f522896b843ca879f76c355.svg";
export { ForwardRef as ReactComponent };